import React, { Suspense, lazy, useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { GetAllSubTopics, SaveSubTopics, deleteSubTopic, updateSubTopics } from '../../../services/CommonService';
import { Button, Table, Modal } from "react-bootstrap";
import { Accordion } from 'react-bootstrap';
const SubQuetion = lazy(() => import("./subjectQuetions/SubQuetions.js"))
function SubTopics({ subtopicprops }) {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const fields = {
        name: '',
        status: '',
        position: '',
        subjectid: subtopicprops.subjectid,
        topicid: subtopicprops.id
    }
    const errors = {
        name: '',
        status: '',
        position: '',
    }
    const [subadminbar, setSubAdminbar] = useState(true);
    useEffect(() => {
        getAllSubTopics()
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        // console.log("constuserdetails",constuserdetails.roles[0]);
        if (constuserdetails?.roles[0] == 'ROLE_SUBADMIN') {
            setSubAdminbar(false)
        }
    }, [])
    const [percent, setPercent] = useState(50);
    const [formfields, setFromFields] = useState(fields);
    const [errorFields, setErrorFields] = useState(errors);
    const [data, setData] = useState([])
    const [postModal, setPostModal] = useState(false);
    const [subTopicdata, setSubTopicData] = useState({})

    const { name, status, position } = formfields

    const getAllSubTopics = async () => {
        const reqdata = {
            pageno: '-1',
            query: { subjectid: subtopicprops.subjectid, topicid: subtopicprops.id }
        }
        const ResponseData = await GetAllSubTopics(reqdata)
        // console.log("subtopic resp", ResponseData.data);
        setData(ResponseData.data)

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }
    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["position"]) {
            formIsValid = false;
            errors["position"] = "*Please enter display position name .";
        }

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter sub topic name .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        // console.log("formfields", formfields);
        const isValid = await validateForm();
        if (isValid) {
            if (!formfields.id) {
                //save
                const Response = await SaveSubTopics(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    getAllSubTopics()
                    setFromFields(fields);
                }

            } else {
                //update
                const Response = await updateSubTopics(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    getAllSubTopics()
                }
            }
        }

    }

    const updateRecord = async (item) => {
        setFromFields(item);

    }
    const deleteRecord = async (item) => {
        const Response = await deleteSubTopic(item);
        if (Response.data.id) {
            notifyTopFullWidth("Data deleted successfully");
            getAllSubTopics()
        }

    }
    const openModal = async (item) => {
        setSubTopicData(item)
        setPostModal(true)

    }
    const closemodal = async () => {
        setPostModal(false)
    }
    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="row">
                <div className="form-group mb-3 col-md-3">
                    <label>Display Position</label>
                    <input component="input"
                        placeholder="display position"
                        name="position"
                        className="form-control"
                        value={position} maxLength={50} onChange={handleChange} />

                    <div className="errorMsg">{errorFields.position}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Sub Topic Name</label>
                    <input component="input"
                        placeholder="subtopic Name"
                        name="name"
                        className="form-control"
                        value={name} maxLength={50} onChange={handleChange} />
                    <div className="errorMsg">{errorFields.name}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <label>Status</label>
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                    <div className="errorMsg">{errorFields.status}</div>
                </div>
                <div className="form-group mb-3 col-md-3">
                    <Button onClick={submitForm} className="me-2" variant="info">
                        Save SubTopic
                    </Button>

                </div>


            </div>
            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Section Items
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">

                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="width80">
                                            <strong>Display Position</strong>
                                        </th>

                                        <th>
                                            <strong>Subtopic Name</strong>
                                        </th>

                                        <th><strong>Status</strong></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(item => (
                                        <tr>
                                            <td>
                                                <strong>{item.position}</strong>
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.status}</td>
                                            <td>
                                                <Button onClick={() => updateRecord(item)} className="me-2"
                                                    variant="info">
                                                    Update
                                                </Button>

                                              {subadminbar &&  <Button onClick={() => deleteRecord(item)} className="me-2" variant="danger">
                                                    Delete
                                                </Button>}
                                               




                                            </td>


                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>

            </Accordion>
            {/* {console.log(data, "check title data")} */}
            <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">
                                {subTopicdata?.name}
                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <Suspense fallback={<div>Loading</div>}>
                                    <SubQuetion items={subTopicdata} />
                                </Suspense>


                            </div>

                        </form>

                    </div>
                </div>
            </Modal>
        </>
    )
}

export default SubTopics